<template>
    <div>
        <SimpleTable ref="simpletable" formclass="Board/form" endpoint="boards" :aditionalColumns="headers" hideNew :hideEdit="!isAdmin" hideDelete inlineToggle updateTime="10">
            <template v-slot="data">
                <h1>Placas</h1>
                <v-divider class="mb-4" />
                <v-layout wrap class="ma-12">
                    <v-flex xs12 sm3>
                        <v-card color="primary">
                            <v-card-text class="white--text">
                                <div class="headline mb-2">
                                    <v-icon dark>functions</v-icon>
                                    {{ total(data.items) }}
                                </div>
                                Cadastradas
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-card color="primary">
                            <v-card-text class="white--text">
                                <div class="headline mb-2">
                                    <v-icon dark>functions</v-icon>
                                    {{ active(data.items) }}
                                </div>
                                Em clientes
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-card color="primary">
                            <v-card-text class="white--text">
                                <div class="headline mb-2">
                                    <v-icon dark>functions</v-icon>
                                    {{ inMaintenance(data.items) }}
                                </div>
                                Em Manutenção
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-card color="primary">
                            <v-card-text class="white--text">
                                <div class="headline mb-2">
                                    <v-icon dark>functions</v-icon>
                                    {{ withError(data.items) }}
                                </div>
                                Em Fábricação
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-divider class="mb-4" />
            </template>

            <template v-slot:extra-column="item">
                <v-chip v-if="item.inMaintenance" class="ma-2" color="warning" outlined>
                    <v-icon left> done </v-icon>
                    Em Manutenção
                </v-chip>
                <v-chip v-else-if="item.approved" class="ma-2" color="success" outlined>
                    <v-icon left> done </v-icon>
                    Aprovada
                </v-chip>
                <v-chip v-else class="ma-2" color="red" outlined>
                    <v-icon left> hourglass_top </v-icon>
                    Teste pendente
                </v-chip>
                <v-btn small color="primary" @click="openHistory(item)" class="ml-2">
                    <v-icon left>history</v-icon>
                    Histórico
                </v-btn>
            </template>
        </SimpleTable>
        
        <BoardHistoryModal v-model="dialog" :board="selectedBoard" />
    </div>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
import BoardHistoryModal from "./BoardHistoryModal";
import { mapGetters } from "vuex";

export default {
    components: {
        SimpleTable,
        BoardHistoryModal,
    },

    data() {
        return {
            headers: [
                { text: this.$t("Disponibilidade"), value: "extra-column", align: "center", sortable: false },
                { text: this.$t("Habilitado"), value: "enable", align: "right", sortable: false },
                { text: this.$t("Modelo"), value: "model", align: "right", sortable: true },
                { text: this.$t("Tipo"), value: "type", align: "right", sortable: true },
                { text: this.$t("Serial"), value: "serialNumber", align: "right", sortable: true },
            ],
            isAdmin: false,
            dialog: false,
            selectedBoard: null,
        };
    },

    mounted() {
        this.isAdmin = this.verifyRole("ADMIN");
    },

    computed: {
        ...mapGetters(["verifyRole"]),
    },

    methods: {
        total(items) {
            return Number.parseFloat(items.length).toFixed(0);
        },
        active(items) {
            return Number.parseFloat(items.reduce((sum, i) => (i.enable ? sum + 1 : sum), 0)).toFixed(0);
        },
        withError(items) {
            return Number.parseFloat(items.reduce((sum, i) => (!i.approved ? sum + 1 : sum), 0)).toFixed(0);
        },
        inMaintenance(items) {
            return Number.parseFloat(items.reduce((sum, i) => (i.inMaintenance ? sum + 1 : sum), 0)).toFixed(0);
        },
        openHistory(board) {
            this.selectedBoard = board;
            this.dialog = true;
        },
    },
};
</script>